@if (carnetEquipement$ | async; as carnetEquipement) {
  <section class="container-background container-fluid content">
    <div class="row">
      <h2 class="page-title col-12">{{carnetEquipement.equipement.nom}}@if (carnetEquipement.equipement.categorie) {
        <small class="ms-3"
        >{{carnetEquipement.equipement.categorie.nom}}</small>
      }
    </h2>
  </div>
  <div class="m-2 p-4 bg-white rounded">
    @if (carnetEquipement.equipement.image) {
      <div class="carnetEquipement.equipement-image mx-auto text-center">
        <img [src]="carnetEquipement.equipement.image.url | backResource" class=" img-fluid img-thumbnail">
      </div>
    }
    <div class="color-blue my-3" [innerHTML]="carnetEquipement.equipement.description"></div>
    @if (carnetEquipement.equipement.entretienFaitPar || carnetEquipement.equipement.periodiciteEntretien) {
      <fieldset>
        <legend>Entretien</legend>
        @if (carnetEquipement.equipement.entretienFaitPar) {
          <div class="mb-2 color-blue">
            <span class="fw-bold">Fait par : </span>
            <app-ref referentiel="entretienFaitPar" [key]="carnetEquipement.equipement.entretienFaitPar"></app-ref>
          </div>
        }
        @if (carnetEquipement.equipement.periodiciteEntretien) {
          <div class="mb-2 color-blue">
            <span class="fw-bold">Périodicité : </span>{{carnetEquipement.equipement.periodiciteEntretien}} mois
          </div>
        }
      </fieldset>
    }
    @if (carnetEquipement.equipement.reference || carnetEquipement.equipement.urlFabriquant || carnetEquipement.equipement.notice) {
      <fieldset>
        <legend>Fabriquant</legend>
        @if (carnetEquipement.equipement.reference) {
          <div class="mb-2 color-blue">
            <span class="fw-bold">Référence : </span>{{carnetEquipement.equipement.reference}}
          </div>
        }
        @if (carnetEquipement.equipement.urlFabriquant) {
          <div class="mb-2 color-blue">
            <span class="fw-bold">Site internet : </span><a [href]="carnetEquipement.equipement.urlFabriquant" target="_blank"
          class="color-saumon">{{carnetEquipement.equipement.urlFabriquant}}</a>
        </div>
      }
      @if (carnetEquipement.equipement.notice) {
        <div class="mb-2 color-blue">
          <span class="fw-bold">Notice : </span><a href="javascript:void(0)"
        (click)="documentService.download(carnetEquipement.equipement.notice.id, carnetEquipement.equipement.notice.token)" class="color-saumon">Télécharger</a>
      </div>
    }
  </fieldset>
}
@if (equipe$ | async) {
  <fieldset>
    <legend>Mes données personnalisées</legend>
    @if (metadata$ | async; as metadata) {
      @if (metadata.reference) {
        <div class="mb-2 color-blue">
          <span class="fw-bold">Référence : </span>{{metadata.reference}}
        </div>
      }
      @if (metadata.urlFabriquant) {
        <div class="mb-2 color-blue">
          <span class="fw-bold">Site internet : </span><a [href]="metadata.urlFabriquant" target="_blank"
        class="color-saumon">{{metadata.urlFabriquant}}</a>
      </div>
    }
    @if (metadata.image) {
      <div class="carnetEquipement.equipement-image mx-auto text-center">
        <img [src]="metadata.image.url | backResource" class=" img-fluid img-thumbnail">
      </div>
    }
    @if (metadata.notice) {
      <div class="mb-2 color-blue">
        <span class="fw-bold">Notice : </span><a href="javascript:void(0)"
      (click)="documentService.download(metadata.notice.id, metadata.notice.token)" class="color-saumon">Télécharger</a>
    </div>
  }
} @else {
  <div class="alert alert-info">Vous n'avez pas encore personnalisé cet équipement</div>
}
<div class="text-center mt-3">
  @if (logement$ | async; as logement) {
    @if (logement.userPermissions.updatable) {
      <a class="btn btn-blue" [routerLink]="'/mes-equipements/personnaliser/' + carnetEquipement.equipement.id">
        <fa-icon [icon]="faPen"></fa-icon>&nbsp;Personnaliser cet équipement
      </a>
    }
  }
</div>
</fieldset>
}
<fieldset>
  <legend>Conseils</legend>
  <div ngbAccordion [closeOthers]="true">
    @if (carnetEquipement.equipement.conseilMiseEnRoute !== '') {
      <div ngbAccordionItem="conseils" [collapsed]="false">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Conseils de mise en route</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <div class="row">
                <div class="col-12 color-blue" [innerHTML]="carnetEquipement.equipement.conseilMiseEnRoute"></div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    }
    @if (carnetEquipement.equipement.conseilEntretien !== '') {
      <div ngbAccordionItem="static-2">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Conseils d'entretien</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <div class="row">
                <div class="col-12 color-blue" [innerHTML]="carnetEquipement.equipement.conseilEntretien"></div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    }
    @if (carnetEquipement.equipement.conseilsCasDePanne !== '') {
      <div ngbAccordionItem="static-3">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Conseils en cas de panne</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <div class="row">
                <div class="col-12 color-blue" [innerHTML]="carnetEquipement.equipement.conseilsCasDePanne"></div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    }
  </div>
</fieldset>
</div>
@if (extraRouter.previousUrl) {
  <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-bottom justify-content-center">
    <a class="btn btn-light" [routerLink]="extraRouter.previousUrl">Fermer</a>&nbsp;
  </nav>
}
</section>
}
